<template>
  <div class="animated fadeIn" id="iframediv">
    <iframe width=100% height=100% :src="src + getcorsdata()" style='border-width: 0px;'></iframe>
  </div>
</template>

<script>

var jwt = require('jsonwebtoken')

export default {
  name: 'dashboard',
  components: {
  },
  data: function () {
    var io = this;
    return {
        //src: "https://www.ropel.it"
    }
  },
  props: [ 'src' ],
  methods: {
    // corsid=11215&schema=a2020
    getcorsdata: function(){
      var secret = "ropels3cr3t"
      try {
        console.log("getcorsdata...",window.keyname)
        var token = sessionStorage.getItem(window.keyname)
        console.log("TOKEN",token)
        var data = jwt.decode(token, secret)  
        return btoa(`corsid=${data.sub.guest.corsistaid}&schema=${data.sub.schema}`)
      } catch (error) {
        console.error("getcorsdata",error)
        return error
      }
    }
  },
  mounted: function(){
    console.log("IFrame src=",this.src)
    document.getElementById('iframediv').parentNode.classList.add("h100");
  }
}
</script>

<style>
    div.h100 {
        height: calc(100% - 80px);
    }
</style>
<style scoped>
    div.animated {
        height: 100%;
    }
</style>
